export interface ProductGroup {
  gsl?: string
  p?: string
  pom?: string
  'pom-v'?: string
}

export interface ProductReviews {
  average: string
  count: number
}

export interface Product {
  hash: string
  title: string
  slug: string
  sku: string
  description: string
  categories: string[]
  category_hashes: string[]
  tags: string[] | null
  keywords: string[]
  image: string
  gallery: string[]
  is_pom: boolean
  product_group: ProductGroup
  recommended: boolean
  questionnaire: string | null
  menu_order: number
  created: number
  price: number
  in_stock: boolean
  reviews: ProductReviews
}

export interface ProductVariant {
  hash: string
  title: string | null
  sku: string | null
  price: string | null
  is_in_stock: boolean
  directions: string | null
  strength: string | null
}

export interface ProductCategoryRef {
  hash: string
  name: string
}

/** Single product from detail API (with variations) */
export interface ProductVariation {
  hash: string
  slug: string
  sku: string
  title: string
  description: string
  in_stock: boolean
  price: number
  image: string
  days_to_reorder: number
  strength: string
  quantity?: string
  directions: string
  pa_ep_strength?: { label: string; slug: string }
}

export interface ProductDetail {
  hash: string
  title: string
  slug: string
  sku: string
  description: string
  description_full?: string
  categories: string[]
  category_hashes: string[]
  keywords: string[]
  gallery: string[]
  is_pom: boolean
  product_group: string
  recommended: boolean
  created: number
  price: number
  in_stock: boolean
  reviews: ProductReviews
  is_reorderable?: boolean
  directions: string
  weight?: number | null
  variations: ProductVariation[]
}

/** Flat variant-level row from products list API */
export interface ProductRow {
  hash: string
  product_hash: string
  product_title: string
  product_sku: string
  product_description: string
  product_directions: string
  prod_group: string
  variant_title: string
  variant_sku: string
  price: string
  is_in_stock: boolean
  variant_directions: string
  strength: string
  quantity: string
  categories: ProductCategoryRef[]
}

export function getPrescriptionType(productGroup: ProductGroup | string | null): string {
  if (!productGroup) return 'N/A'

  if (typeof productGroup === 'string') {
    return productGroup.toUpperCase()
  }

  if (productGroup.pom) return 'POM'
  if (productGroup.p) return 'P'
  if (productGroup.gsl) return 'GSL'
  if (productGroup['pom-v']) return 'POM-V'
  return 'N/A'
}
